import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SafePipe } from 'app/core/pipes/safe.pipe';
import { DateAgoPipe } from 'app/core/pipes/date-ago.pipe';
import { TextToLinkDirective } from 'app/core/directives/text-to-link/text-to-link.directive';
import { PpHttpModule } from '@penpencil/common';
import { environment } from 'environments/environment';
import { MathjaxComponent } from 'app/core/directives/mathjax/mathjax.component';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ErrorDialogModule } from 'app/core/error-dialog/error-dialog.module';
import { TruncatePipe } from 'app/core/pipes/truncate.pipe';
import { EvalFuncPipe } from 'app/core/pipes/eval-func.pipe';
import { ImageUploadModalComponent } from 'app/core/bulk/image-bulk/image-upload-modal.component';

@NgModule({
    declarations: [
        DateAgoPipe,
        EvalFuncPipe,
        SafePipe,
        TextToLinkDirective,
        MathjaxComponent,
        TruncatePipe,
        ImageUploadModalComponent,
    ],
    imports: [
        CommonModule,
        MatCardModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        MatTooltipModule,
        FormsModule,
        ReactiveFormsModule,
        PpHttpModule.forRoot(environment.apiConfig),
    ],
    providers: [SafePipe],
    exports: [
        CommonModule,
        FormsModule,
        ErrorDialogModule,
        ReactiveFormsModule,
        DateAgoPipe,
        EvalFuncPipe,
        SafePipe,
        TextToLinkDirective,
        MathjaxComponent,
        TruncatePipe,
    ],
})
export class SharedModule {}
